import React from 'react';
import PluginComponent from '../plugin-component';
import _merge from 'lodash.merge';
import PixelImage from './pixel-image';

class TrackingPixels extends PluginComponent {
    constructor(props) {
        super(props);
        //console.log("[TrackingPixels Plugin] props:", props);
        this.state = this.getInitialState();
        this.subscriptions = [];

    }
    getInitialState() {
        const { config } = this.props;
        const pixels = config != null ? config : {
            "start": "",
            "25pct": "",
            "50pct": "",
            "75pct": "",
            "100pct": ""
        };
        return {
            "start": {
                "track": false,
                "tracked": false,
                "src": pixels["start"]
            },
            "25pct": {
                "track": false,
                "tracked": false,
                "src": pixels["25pct"]
            },
            "50pct": {
                "track": false,
                "tracked": false,
                "src": pixels["50pct"]
            },
            "75pct": {
                "track": false,
                "tracked": false,
                "src": pixels["75pct"]
            },
            "100pct": {
                "track": false,
                "tracked": false,
                "src": pixels["100pct"]
            }
        }
    }
    handleEnded(eventData) {
        //console.log("[TrackingPixels Plugin] handleEnded:", eventData, "\nstate:", this.state);
        this.trackEnd()
    }

    handlePlaying(eventData) {
        this.trackStart();
    }
    handleTimeupdate(eventData) {
        let { currentTime, duration } = eventData.state;
        let timePercent = (currentTime / duration) * 100;
        // AUDIO PLAYER MAY NOT TRIGGER PLAYING EVENT TO TRACK START
        this.trackStart();

        this.trackMilestones(timePercent);
    }
    trackEnd() {
        const { state } = this;
        if (state["100pct"].track === false) {
            // Track all pixels
            const newState = _merge({}, state, {
                "start": {
                    "track": true
                },
                "25pct": {
                    "track": true
                },
                "50pct": {
                    "track": true
                },
                "75pct": {
                    "track": true
                },
                "100pct": {
                    "track": true
                }
            })
            this.setState(newState);
        }
    }
    trackMilestones(timePercent) {
        const { state } = this;

        let newState = {}
        if (timePercent >= 25 && state["25pct"].track === false) {
            newState = _merge({}, state, newState, {
                "25pct": {
                    "track": true
                }
            })
        }
        if (timePercent >= 50 && state["50pct"].track === false) {
            newState = _merge({}, state, newState, {
                "50pct": {
                    "track": true
                }
            })
        }
        if (timePercent >= 75 && state["75pct"].track === false) {
            newState = _merge({}, state, newState, {
                "75pct": {
                    "track": true
                }
            })
        }
        if ((Object.keys(newState)).length > 0) {
            this.setState(newState);
        }
    }
    trackStart() {
        const { state } = this;

        if (state.start.track === false) {
            const newState = _merge({}, state, {
                "start": {
                    "track": true
                }
            })
            this.setState(newState);
        }
    }
    pluginComponentDidMount() {
        this.destroySubscriptions();

        const { player: amp } = this.props;

        if (amp.playState == "playing") {
            this.handlePlaying();
        }

        let time$ = amp.AmpEventsSources["timeupdate"].subscribe(eventData => {
            this.handleTimeupdate(eventData);
        })

        let playing$ = amp.AmpEventsSources["playing"].subscribe(eventData => {
            this.handlePlaying(eventData);
        })
        let end$ = amp.AmpEventsSources["ended"].subscribe(eventData => {
            this.handleEnded(eventData);
        })
        this.subscriptions.push(playing$)
        this.subscriptions.push(time$);
        this.subscriptions.push(end$);
    }

    pluginComponentDidUpdate(prevProps, prevState) {
        const { state } = this;
        if (state['100pct'].track === true) {
            // Reset tracking for replay
            const newState = this.getInitialState();
            this.setState(newState);
        }
    }
    render() {
        const { state } = this;
        const styles = {
            "display": "none"
        }
        return (
            <div className="tracking-pixels" style={styles}>
                <PixelImage key={"pixel-0"} {...state["start"]} />
                <PixelImage key={"pixel-25"} {...state["25pct"]} />
                <PixelImage key={"pixel-50"} {...state["50pct"]} />
                <PixelImage key={"pixel-75"} {...state["75pct"]} />
                <PixelImage key={"pixel-100"} {...state["100pct"]} />
            </div>
        )
    }
    static get containerClass() {
        return "tracking-pixels-plugin-container";
    }

}

window.akamai.amp.AMP.registerPlugin("TrackingPixels", TrackingPixels.create.bind(TrackingPixels));

export default TrackingPixels